import { useRef } from 'react';
import { Toast } from 'primereact/toast';

type ToastSeverity = 'success' | 'info' | 'warn' | 'error';

export const useToast = () => {
  const toastRef = useRef<Toast>(null);

  const showToast = (
    severity: ToastSeverity,
    summary: string,
    detail: string,
    life: number = 3000
  ) => {
    toastRef.current?.show({ severity, summary, detail, life });
  };

  const showSuccess = (message: string, detail?: string) =>
    showToast('success', message, detail || '');

  const showError = (message: string, detail?: string) =>
    showToast('error', message, detail || '');

  const showInfo = (message: string, detail?: string) =>
    showToast('info', message, detail || '');

  const showWarning = (message: string, detail?: string) =>
    showToast('warn', message, detail || '');

  return {
    toastRef,
    showToast,
    showSuccess,
    showError,
    showInfo,
    showWarning,
  };
};
